import arrayFromConstructorAndList$1 from './array-from-constructor-and-list.js';
import typedArraySpeciesConstructor$1 from './typed-array-species-constructor.js';

var arrayFromConstructorAndList = arrayFromConstructorAndList$1;
var typedArraySpeciesConstructor = typedArraySpeciesConstructor$1;

var typedArrayFromSpeciesAndList = function (instance, list) {
  return arrayFromConstructorAndList(typedArraySpeciesConstructor(instance), list);
};

export { typedArrayFromSpeciesAndList as default };
